module.exports = __webpack_public_path__ + "static/media/pattern-dot.97ef962c.svg";